import { useState, type FormEvent } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    setLoading(true);
    try {
      const r = await register({ username, email, password, confirmPassword });
      if (r.ok) navigate('/dashboard', { replace: true });
      else setError(r.message || 'Registration failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-vh-100 d-flex flex-column" style={{ background: 'linear-gradient(180deg,#f8f9fe,#fff)' }}>
      <nav className="navbar navbar-dark public-hero">
        <div className="container">
          <Link className="navbar-brand" to="/">
            M3UStudio
          </Link>
          <Link className="btn btn-light btn-sm rounded-pill" to="/login">
            Sign in
          </Link>
        </div>
      </nav>
      <div className="flex-grow-1 d-flex align-items-center py-5">
        <div className="container" style={{ maxWidth: 440 }}>
          <div className="card shadow border-0 rounded-4 overflow-hidden">
            <div style={{ height: 4, background: 'linear-gradient(87deg,#5e72e4,#825ee4)' }} />
            <div className="card-body p-4">
              <p className="small text-uppercase text-primary fw-semibold mb-1">M3UStudio</p>
              <h1 className="h4 fw-bold mb-3">Create your account</h1>
              {error && <div className="alert alert-danger py-2 small">{error}</div>}
              <form onSubmit={onSubmit}>
                <div className="mb-3">
                  <label className="form-label" htmlFor="reg-u">
                    Username
                  </label>
                  <input
                    id="reg-u"
                    className="form-control"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    minLength={3}
                    autoComplete="username"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="reg-e">
                    Email
                  </label>
                  <input
                    id="reg-e"
                    type="email"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="email"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="reg-p">
                    Password
                  </label>
                  <input
                    id="reg-p"
                    type="password"
                    className="form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                </div>
                <div className="mb-4">
                  <label className="form-label" htmlFor="reg-c">
                    Confirm password
                  </label>
                  <input
                    id="reg-c"
                    type="password"
                    className="form-control"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    autoComplete="new-password"
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary w-100 rounded-pill py-2" disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" />
                      Creating…
                    </>
                  ) : (
                    'Create account'
                  )}
                </button>
              </form>
              <p className="small text-center mt-3 mb-0">
                <Link to="/login">Already have an account?</Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
